export const RATIO = 0.25;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/audio/constant.ts